import { client } from "api";

export type AddUserToCompanyRequest = {
  userId: string;
  companyId: string;
};

export type AddUserToCompanyResponse = string;

export const addUserToCompany = (
  { userId, companyId }: AddUserToCompanyRequest
) =>
  client.post<AddUserToCompanyResponse>(`/company/${companyId}/users/${userId}`, { userId, companyId }).then((res) => res.data);
